// ** React Imports
import { Fragment } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { Button } from 'reactstrap'
import Typography from '@mui/material/Typography'
import { Icon } from '@iconify/react'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'

// ** Third Party Imports
import { useDropzone } from 'react-dropzone'
import { useOnboarding } from './OnboardingContext'

const FileUploaderMultiple = () => {
  // ** State
  const {files, setFiles, setFilesCurrentAction} = useOnboarding()
  const { t } = useTranslation()

  // ** Hooks
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: acceptedFiles => {
      setFiles(previous => [...previous, ...acceptedFiles.map(file => Object.assign(file))])
    }
  })

  const handleRemoveFile = file => {
    const uploadedFiles = files
    const filtered = uploadedFiles.filter(i => i.name !== file.name)
    setFiles([...filtered])
  }

  const uploadFiles = () => {
    setFilesCurrentAction("upload")
  }

  const fileList = files.map(file => (
      <Chip label={file.name} key={file.name} color='info' variant='outlined' avatar={<Icon icon='tabler:file-description' />} onDelete={() => handleRemoveFile(file)} />
  ))

  const handleRemoveAllFiles = () => {
    setFiles([])
  }

  return (
    <Fragment>
      <div {...getRootProps({ className: 'dropzone' })} >
        <input {...getInputProps()} />
        <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <Box
            sx={{
              mb: 1.75,
              width: 48,
              height: 48,
              display: 'flex',
              borderRadius: 1,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#6f6ce8'
            }}
          >
            <Icon icon='tabler:upload' fontSize='1.75rem' color='white' />
          </Box>
          <Typography variant='h4' sx={{ mb: 2.5 }}>
            {t('drop-files')}
          </Typography>
        </Box>
      </div>
      {files.length ? (
        <div>
          <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1}>{fileList}</Stack>
          <Box component="span" style={{ marginTop: '10px', display: 'flex', alignItems: 'right' }}>
            <Button type='button' color='danger' onClick={handleRemoveAllFiles}>
              {t('remove-all')}
            </Button>
            <Button style={{ marginLeft: '10px' }} type='button' color='success' onClick={uploadFiles}>{t('upload-files')}</Button>
          </Box>
        </div>
      ) : null}
      <div></div>
    </Fragment>
  )
}

export default FileUploaderMultiple
